var _path, _g, _path2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSaftyBadge = function SvgSaftyBadge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 159,
    viewBox: "0 0 140 159",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1143 41.4713L70.0003 19.9092L113.886 41.4713L113.881 41.8108C113.545 61.688 112.644 115.04 70.0003 125.76C27.1117 114.979 26.4467 61.0733 26.1143 41.4713Z",
    fill: "#1D6BB5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0001 11L122 36.5487L121.909 41.9455L121.905 42.1715C121.737 52.105 121.413 71.3831 115.443 89.6857C109.371 108.303 96.9685 127.221 71.967 133.506L70.0001 134L68.0332 133.506C42.8849 127.184 30.4879 108.084 24.4528 89.3638C18.5811 71.1502 18.2603 52.0156 18.0948 42.1429C18.0918 41.961 18.0888 41.7822 18.0858 41.6067L18 36.5488L70.0001 11ZM113.88 41.8113L113.886 41.4719L70.0001 19.9097L26.1141 41.4719C26.116 41.5839 26.1179 41.697 26.1198 41.8113C26.4555 61.6885 27.3566 115.041 70.0001 125.76C112.644 115.041 113.545 61.6886 113.88 41.8113Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.076 47.0043C96.6838 48.1171 97.0805 50.3159 95.9621 51.9156L63.8912 97.7835C63.2212 98.7418 62.1181 99.3083 60.9449 99.2968C59.7717 99.2852 58.6801 98.6971 58.0293 97.7258L43.9983 76.7861C42.9119 75.1647 43.3523 72.9741 44.9819 71.8932C46.6115 70.8123 48.8133 71.2504 49.8997 72.8718L61.0424 89.501L90.1397 47.8858C91.2582 46.2862 93.4682 45.8915 95.076 47.0043Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 140,
    height: 159,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSaftyBadge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/safty-badge.b27e67b9.svg";
export { ForwardRef as ReactComponent };